import React, { useState } from 'react';
import { ArrowLeft, Eye, EyeOff, UserPlus } from 'lucide-react';
import companyService from '../../services/companyService';
import { useToast, ToastContainer } from '../common/Toast';

const CreateAdminModal = ({ show, onClose, admin, onChange, onSave }) => {
  const [showPassword, setShowPassword] = useState(false);
  if (!show) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange({ ...admin, [name]: value });
  };

  return (
    <div className="modal-backdrop" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 1050 }} onClick={onClose}>
      <div className="modal-content" style={{ backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 4px 20px rgba(0,0,0,0.15)', maxWidth: '560px', width: '100%', margin: 16 }} onClick={e => e.stopPropagation()}>
        <div style={{ padding: '20px 24px', borderBottom: '1px solid #e5e7eb' }}>
          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 600, color: 'var(--gold-primary)' }}>Create Client Admin</h3>
        </div>
        <div style={{ padding: '24px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', marginBottom: 16 }}>
            <div>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 13, fontWeight: 500, color: '#374151' }}>Admin First Name <span style={{ color: '#dc2626' }}>*</span></label>
              <input type="text" name="adminFirstName" value={admin.adminFirstName || ''} onChange={handleChange} placeholder="Enter First Name" style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14 }} />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 13, fontWeight: 500, color: '#374151' }}>Admin Last Name <span style={{ color: '#dc2626' }}>*</span></label>
              <input type="text" name="adminLastName" value={admin.adminLastName || ''} onChange={handleChange} placeholder="Enter Last Name" style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14 }} />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 13, fontWeight: 500, color: '#374151' }}>Admin E-mail ID <span style={{ color: '#dc2626' }}>*</span></label>
              <input type="email" name="adminEmail" value={admin.adminEmail || ''} onChange={handleChange} placeholder="Enter Admin E-mail ID" style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14 }} />
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 13, fontWeight: 500, color: '#374151' }}>Admin Password <span style={{ color: '#dc2626' }}>*</span></label>
              <div style={{ position: 'relative' }}>
                <input type={showPassword ? 'text' : 'password'} name="adminPassword" value={admin.adminPassword || ''} onChange={handleChange} placeholder="Enter Password" style={{ width: '100%', padding: '8px 12px 8px 12px', paddingRight: 36, border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14 }} />
                <button type="button" onClick={() => setShowPassword(!showPassword)} style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}>{showPassword ? <EyeOff size={16} /> : <Eye size={16} />}</button>
              </div>
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 13, fontWeight: 500, color: '#374151' }}>Admin Phone</label>
              <input type="text" name="adminPhone" value={admin.adminPhone || ''} onChange={handleChange} placeholder="Enter Phone" style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14 }} />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 13, fontWeight: 500, color: '#374151' }}>Status <span style={{ color: '#dc2626' }}>*</span></label>
              <select style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14, color: '#059669' }} defaultValue="Approved">
                <option value="Approved">Approved</option>
                <option value="Pending">Pending</option>
              </select>
            </div>
          </div>
        </div>
        <div style={{ padding: '16px 24px', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', gap: 12 }}>
          <button type="button" onClick={onClose} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 16px', border: '1px solid #d1d5db', borderRadius: 6, background: '#fff', cursor: 'pointer', fontSize: 14 }}>
            <ArrowLeft size={16} /> Back
          </button>
          <button type="button" onClick={onSave} style={{ padding: '8px 20px', borderRadius: 6, background: 'var(--gold-primary)', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 14, fontWeight: 500 }}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

const TenantOnboardingForm = ({ onSuccess }) => {
  const { error: showError, success: showSuccess, toasts, removeToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showAdminModal, setShowAdminModal] = useState(false);
  const [company, setCompany] = useState({
    companyId: '',
    companyName: '',
    companyType: 'service',
    domain: '',
    description: ''
  });
  const [admin, setAdmin] = useState({
    adminFirstName: '',
    adminLastName: '',
    adminEmail: '',
    adminPassword: '',
    adminPhone: ''
  });

  const handleCompanyChange = (e) => {
    const { name, value } = e.target;
    setCompany(prev => ({ ...prev, [name]: value }));
    if (error) setError('');
  };

  const handleAdminChange = (newAdmin) => {
    setAdmin(prev => ({ ...prev, ...newAdmin }));
  };

  const openAdminModal = () => setShowAdminModal(true);
  const closeAdminModal = () => setShowAdminModal(false);

  const saveAdminFromModal = () => {
    if (!admin.adminFirstName || !admin.adminLastName || !admin.adminEmail || !admin.adminPassword) {
      showError('First name, last name, email and password are required.');
      return;
    }
    setShowAdminModal(false);
    showSuccess('Admin details added. Click Create Tenant to complete.');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!company.companyName || !company.companyType) {
      setError('Company Name and Company Type are required.');
      return;
    }
    if (!admin.adminFirstName || !admin.adminLastName || !admin.adminEmail || !admin.adminPassword) {
      setError('Please add the client admin using the Create Admin button.');
      return;
    }
    setLoading(true);
    try {
      const payload = {
        companyId: company.companyId.trim().toUpperCase(),
        companyName: company.companyName.trim(),
        companyType: company.companyType,
        domain: company.domain?.trim() || undefined,
        description: company.description?.trim() || undefined,
        adminFirstName: admin.adminFirstName.trim(),
        adminLastName: admin.adminLastName.trim(),
        adminEmail: admin.adminEmail.trim().toLowerCase(),
        adminPassword: admin.adminPassword,
        adminPhone: admin.adminPhone?.trim() || undefined
      };
      await companyService.onboard(payload);
      showSuccess('Tenant created successfully.');
      onSuccess?.();
    } catch (err) {
      const msg = err.response?.data?.message || err.message || 'Failed to create tenant.';
      setError(msg);
      showError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="project-form-card" style={{ borderTop: 'none', width: '100%', maxWidth: '100%', borderLeft: '4px solid var(--gold-primary)' }}>
        <div style={{ padding: '20px 24px' }}>
          <h3 style={{ margin: '0 0 4px 0', fontSize: '16px', fontWeight: 600, color: '#1f2937' }}>Company Registration</h3>
          <p style={{ margin: 0, fontSize: 13, color: '#6b7280' }}>Register a new tenant (company) and assign a client admin.</p>
        </div>
        <form onSubmit={handleSubmit} style={{ padding: '0 24px 24px' }}>
          {error && (
            <div style={{ marginBottom: 16, padding: '10px 14px', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 6, color: '#dc2626', fontSize: 14 }}>
              {error}
            </div>
          )}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: 16 }}>
            <div>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 13, fontWeight: 500, color: '#374151' }}>Workspace ID <span style={{ color: '#dc2626' }}>*</span></label>
              <input type="text" name="companyId" value={company.companyId} onChange={handleCompanyChange} placeholder="e.g. NEXUS-01" style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14 }} required />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 13, fontWeight: 500, color: '#374151' }}>Company Legal Name <span style={{ color: '#dc2626' }}>*</span></label>
              <input type="text" name="companyName" value={company.companyName} onChange={handleCompanyChange} placeholder="Enter Legal Entity Name" style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14 }} required />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 13, fontWeight: 500, color: '#374151' }}>Company Type <span style={{ color: '#dc2626' }}>*</span></label>
              <select name="companyType" value={company.companyType} onChange={handleCompanyChange} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14 }}>
                <option value="service">Service</option>
                <option value="real_estate">Real Estate</option>
                <option value="life_sciences">Life Sciences</option>
              </select>
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 13, fontWeight: 500, color: '#374151' }}>Domain</label>
              <input type="text" name="domain" value={company.domain} onChange={handleCompanyChange} placeholder="e.g. company.com" style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14 }} />
            </div>
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', marginBottom: 6, fontSize: 13, fontWeight: 500, color: '#374151' }}>Description</label>
            <textarea name="description" value={company.description} onChange={handleCompanyChange} placeholder="Enter company description" rows={2} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14, resize: 'vertical' }} />
          </div>

          <div style={{ marginBottom: 20, padding: '12px 16px', background: '#f8fafc', borderRadius: 6, border: '1px solid #e2e8f0' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
              <div>
                {admin.adminEmail ? (
                  <span style={{ fontSize: 14, color: '#374151' }}>
                    Admin: <strong>{admin.adminFirstName} {admin.adminLastName}</strong> ({admin.adminEmail})
                  </span>
                ) : (
                  <span style={{ fontSize: 14, color: '#6b7280' }}>No admin added yet.</span>
                )}
              </div>
              <button type="button" onClick={openAdminModal} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 14px', background: 'var(--gold-primary)', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14, fontWeight: 500 }}>
                <UserPlus size={16} /> Create Admin
              </button>
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
            <button type="submit" disabled={loading} style={{ padding: '10px 24px', background: 'var(--gold-primary)', color: '#fff', border: 'none', borderRadius: 6, cursor: loading ? 'not-allowed' : 'pointer', fontSize: 14, fontWeight: 500 }}>
              {loading ? 'Creating...' : 'Create Tenant'}
            </button>
          </div>
        </form>
      </div>

      <CreateAdminModal show={showAdminModal} onClose={closeAdminModal} admin={admin} onChange={handleAdminChange} onSave={saveAdminFromModal} />
      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </>
  );
};

export default TenantOnboardingForm;
